import { ChevronRight } from '@mui/icons-material';
import { Grid, IconButton, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import './style.scss';

interface LinkButtonProps {
  href: string;
  linkText: string;
}

export function LinkButton(props: LinkButtonProps) {
  return (
    <Grid container className="link-button-container">
      <Grid item flex={1} className="link-button-item">
        <Link to={props.href} className="link-button-link">
          <IconButton
            disableRipple
            color="inherit"
            style={{ width: '100%', backgroundColor: 'inherit' }}
          >
            <Typography variant="body1" className="link-button-text">
              {props.linkText}
            </Typography>
            <ChevronRight />
          </IconButton>
        </Link>
      </Grid>
    </Grid>
  );
}
